<template>
    <ac-modal :title="'Outstanding Items'" ref="modal">
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning" v-if="bankingInfoNeeded">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11">
                                Your account is set to receive payments with no banking information saved.<br>
                                Please click
                                <router-link :to="{name:'bankingInfo',params:{providerEntityId}}">here</router-link>
                                to update your profile with current banking information.
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-warning" v-if="providersWithoutNpi.length>0  && !isPhysician">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11">
                                You have {{providersWithoutNpi.length}} physician(s) with no NPI setup.<br>
                                <p v-for="noNpi in providersWithoutNpi">
                                    {{noNpi.name}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-warning" v-if="providersWithoutNpi.length===1  && isPhysician">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11">
                                Please click
                                <router-link :to="{name:'editProfile',providerEntityId}">here</router-link>
                                to update your <span style="font-weight: bold;">National Provider Identifier</span>.
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-warning" v-if="physicianLimitReached">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11">
                                You have reached the maximum number of healthcare provider profiles allowed in your membership: {{maxNumberOfPhysicians}} profiles.
                                <br>Please email us at support@accresa.com to upgrade your account
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "OutstandingItemsModal",
        props: {providerEntityId: {type: [Number], required: true}},
        computed: {
            ...mapGetters(['bankingInfoNeeded', 'providersWithoutNpi', 'isPhysician', 'physicianLimitReached', 'maxNumberOfPhysicians'])
        },
        methods: {
            showModal() {
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>

</style>